module.exports = __webpack_public_path__ + "static/media/Bitspilani25yearsLogo.1b7008cf.png";